import { registerSpanErrorInstrumentation } from './errors.js';

/**
 * @deprecated Use `registerSpanErrorInstrumentation()` instead. In v9, this function will be removed. Note that you don't need to call this in Node-based SDKs or when using `browserTracingIntegration`.
 */
function addTracingExtensions() {
  registerSpanErrorInstrumentation();
}

export { addTracingExtensions };
//# sourceMappingURL=hubextensions.js.map



// WEBPACK FOOTER //
// ./node_modules/@sentry/core/build/esm/tracing/hubextensions.js